// extracted by mini-css-extract-plugin
export var quillEditor = "_g8-1";
export var variable = "_g8-0";